<template>
  <div class="search-map-loader animation-gradient">
    <v-icon :color="colors.hwayzGray" size="120">
      map
    </v-icon>
  </div>
</template>

<script>
import colors from '../../../scss/_colors.scss'

export default {
  data() {
    return { colors }
  }
}
</script>

<style lang="sass" scoped>
.search-map-loader
  position: relative
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 100%
  border: 1rem solid $hwayzLightGray
  animation-duration: 1s
  z-index: 1
  i
    border-radius: 50%
    padding: 3rem
    border: 0.5rem solid $hwayzLightGray

.animation-gradient
  background: linear-gradient(to right, #f2f2f2 20%, #fafafa 50%, #f2f2f2 80%)
  background-size: 40rem 10rem
  animation-name: animation-gradient
  animation-iteration-count: infinite
  animation-timing-function: linear
  animation-fill-mode: forwards

@keyframes animation-gradient
  0%
    background-position: -20rem 0
  100%
    background-position: 20rem 0

@-webkit-keyframes animation-gradient
  0%
    background-position: -20rem 0
  100%
    background-position: 20rem 0
</style>
